import GenerateStep from "@/src/views/mailboxes/steps/GenerateStep.vue";
import ManageStep from "@/src/views/mailboxes/steps/ManageStep.vue";
import CheckoutStep from "@/src/views/mailboxes/steps/CheckoutStep.vue";

export const MAILBOX_STEPS = {
  GENERATE: "GENERATE",
  MANAGE: "MANAGE",
  CHECKOUT: "CHECKOUT",
};

export const STEP_LABELS = {
  [MAILBOX_STEPS.GENERATE]: "Generate",
  [MAILBOX_STEPS.MANAGE]: "Manage",
  [MAILBOX_STEPS.CHECKOUT]: "Checkout",
};

export const STEP_COMPONENTS = {
  [MAILBOX_STEPS.GENERATE]: GenerateStep,
  [MAILBOX_STEPS.MANAGE]: ManageStep,
  [MAILBOX_STEPS.CHECKOUT]: CheckoutStep,
};

export const DEFAULT_MAILBOX_DATA = {
  domains: [],
  mailboxesPerDomain: 5,
  nameType: "combo",
  signature: "",
  forwardingEmail: "",
  checkoutData: {
    domains: [],
    mailboxes: [],
    totalCredits: 0,
  },
  formattedMailboxes: {
    domains: [],
  },
  responseData: {},
  preservedMailboxes: [],
  isRestoringFromPreserved: false,
};

export const NAME_TYPES = {
  COMBO: "combo",
  FIRST_LAST: "first_last",
  FIRST_INITIAL_LAST: "first_initial_last",
  FIRST: "first",
  LAST: "last",
};

export const MAILBOX_STATUS = {
  CONNECTED: "CONNECTED",
  DISCONNECTED: "DISCONNECTED",
};
